import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const ButtonSpinner = ({ color }) => {
  return <CircularProgress size="1rem" />;
};

export default ButtonSpinner;
